<template lang="pug">
  div.sign-in-bubble-container(@click="handleBubbleClick" v-platform-expose="moduleExpose")
    .sign-in-bubble-coin(:class="{ 'is-today': !didSignToday }")
      .sign-in-bubble-account(v-if="rewardAmount") {{ rewardAmount }}
      .sign-in-bubble-title {{ didSignToday ? '明日签到' : '今日签到' }}
</template>

<script>
import SPM from '@/pages/welfare/common/spm';
import { debounce } from '@/utils';

export default {
  name: 'SignInBubble',
  props: {
    // 签到扩展信息
    extInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    didSignToday() {
      return !!this.extInfo.didSignToday;
    },
    // 根据签到状态切换今日/明日金额
    rewardAmount() {
      const { bountyCountToday = 0, bountyCountTomorrow = 0 } = this.extInfo;
      return this.didSignToday ? bountyCountTomorrow : bountyCountToday;
    },
  },
  methods: {
    moduleExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_signUpBubble',
        contentId: 'platform_signUpBubble',
        businessInfo: {
          signUpWords: this.didSignToday ? '明日签到' : '今日签到',
        },
      });
    },
    handleBubbleClick: debounce(function handleBubbleClick() {
      SPM.clickButton({
        buttonName: 'platform_signUpBubble',
        businessInfo: {
          signUpWords: this.didSignToday ? '明日签到' : '今日签到',
        },
      });
      this.$emit('bubbleClick');
    }, 500, true),
  },
};
</script>

<style lang="less" scoped>
.sign-in-bubble-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @keyframes float {
    0%,
    100% {
      transform: translateY(-0.05rem);
    }

    50% {
      transform: translateY(0);
    }
  }

  .sign-in-bubble-coin {
    padding-top: 0.1rem;
    opacity: 0.5;
    animation: float 2s ease-in-out infinite;
    width: 0.64rem;
    height: 0.64rem;
    background: url('https://m.hellobike.com/6737212e_bubble%20(1).png') no-repeat center center;
    background-size: contain;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &.is-today {
      opacity: 1;
    }

    .sign-in-bubble-account {
      font-family: 'DIN Alternate Bold', sans-serif;
      font-size: 0.2rem;
      height: 0.23rem;
      line-height: 0.23rem;
      font-weight: 700;
      color: #662800;
    }
  }

  .sign-in-bubble-title {
    font-size: 0.09rem;
    line-height: 0.13rem;
    height: 0.13rem;
    margin-top: -0.02rem;
    font-weight: 400;
    color: #7f3200;
  }
}
</style>
